import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=3dd16f6e&scoped=true&"
import script from "./RecommendList.vue?vue&type=script&lang=ts&"
export * from "./RecommendList.vue?vue&type=script&lang=ts&"
import style0 from "./RecommendList.vue?vue&type=style&index=0&id=3dd16f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd16f6e",
  null
  
)

export default component.exports